// Libraries
import { FormElems, Alert } from '../';
import {
    initiateRefundRequest,
    initiateRefundError,
} from '../../containers/Refund/redux/refund.actions';
import { SUCCESS_MESSAGES } from '../../utils/constants/toastMessages';
import { TRANSACTION_TYPE } from '../../utils/constants/commonValues';
import validate from './validator';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

// Components

// Actions

// Validator

// Styles
import './refundForm.scss';

const RefundForm = props => {
    const { actions, closePopup, data, handleSubmit, refundData, auth } = props;
    const { refundStatus } = refundData;

    useEffect(() => {
        if (refundStatus.isSuccess) {
            toast.info(SUCCESS_MESSAGES.REFUND(TRANSACTION_TYPE.REFUND));
            closePopup(true);
        }
        return () => {
            if (refundStatus.isSuccess) {
                actions.initiateRefundError({ error: {} });
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refundStatus.isSuccess]);

    useEffect(() => {
        // Reset message
        return () => {
            actions.initiateRefundError({ message: '' });
        };
    }, [actions]);

    const handleFormSubmit = values => {
        const refundType =
            values.refundType &&
            values.refundType.length > 0 &&
            values.refundType[0] === 'ONLINE'
                ? 'ONLINE'
                : 'OFFLINE';
        const request = {
            currency: 'INR',
            merchantId: data.merchantId,
            refundAmount: values.refundAmount,
            txnReferenceId: data.transactionReferenceNumber,
            refundType,
        };
        actions.initiateRefundRequest(request);
    };

    return (
        <form className="refund-view">
            {['MERCHANT', 'MLE'].includes(auth?.userDetails?.userLevel) ? (
                <div className="form-section action">
                    <p className="label">Refund Amount</p>

                    <div className="wrap-input">
                        <Field
                            name="refundAmount"
                            type="number"
                            component={FormElems.Input}
                            min={1}
                            step=".01"
                            placeholder="Enter Refund Amount"
                        />
                        <FormElems.Button
                            buttonType="primary"
                            text="SUBMIT"
                            type="button"
                            isDisable={
                                data.transactionType === TRANSACTION_TYPE.REFUND
                            }
                            handleClick={handleSubmit(handleFormSubmit)}
                        />
                    </div>
                    {data.paymentMode === 'UPI' ? (
                        <div className="refund-type-switch">
                            <Field
                                name="refundType"
                                defaultValues="OFFLINE"
                                options={[
                                    { label: 'Refund Online', value: 'ONLINE' },
                                ]}
                                valueField="value"
                                labelField="label"
                                component={FormElems.Switch}
                            />
                        </div>
                    ) : (
                        <> </>
                    )}
                    {refundStatus.message ? (
                        <Alert>{refundStatus.message}</Alert>
                    ) : null}
                </div>
            ) : (
                <></>
            )}
            <div className="refund-title">Refund Detail</div>
            <div className="form-section three">
                <div className="form-field">
                    <p className="label">Amount</p>
                    <p className="user-text">{data.transactionAmount}</p>
                </div>
                <div className="form-field">
                    <p className="label">Customer Name</p>
                    <p className="user-text">{data.customerName}</p>
                </div>
                <div className="form-field">
                    <p className="label">Customer ID</p>
                    <p className="user-text">{data.customerID}</p>
                </div>
            </div>
            <div className="form-section">
                <div className="form-field">
                    <p className="label">FCPG TXN ID</p>
                    <p className="user-text">
                        {data.transactionReferenceNumber}
                    </p>
                </div>
                <div className="form-field">
                    <p className="label">Merchant TXN ID</p>
                    <p className="user-text">{data.orderId}</p>
                </div>
            </div>
            <div className="form-section">
                <div className="form-field">
                    <p className="label">RRN</p>
                    <p className="user-text">{data.rrnArn}</p>
                </div>
                <div className="form-field">
                    <p className="label">Date Time</p>
                    <p className="user-text">{data.transactionDateAndTime}</p>
                </div>
            </div>
            <div className="form-section">
                <div className="form-field">
                    <p className="label">Payment Mode</p>
                    <p className="user-text">{data.paymentMode}</p>
                </div>
                <div className="form-field">
                    <p className="label">Platform</p>
                    <p className="user-text">{data.platform}</p>
                </div>
            </div>
            <div className="form-section">
                <div className="form-field">
                    <p className="label">Card Number</p>
                    <p className="user-text">{data.maskedCardNumber}</p>
                </div>
            </div>
        </form>
    );
};

const mapStateToProps = ({ auth, refundData, form }) => ({
    auth,
    refundData,
    formData: form['refund-form'],
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            initiateRefundRequest,
            initiateRefundError,
        },
        dispatch
    ),
});

RefundForm.propTypes = {
    actions: PropTypes.object,
    handleSubmit: PropTypes.func,
    closePopup: PropTypes.func,
    data: PropTypes.object,
    refundData: PropTypes.object,
    auth: PropTypes.object,
};

export default compose(
    reduxForm({
        form: 'refund-form',
        validate,
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(RefundForm);
